import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router';
import { rememberInviteCode } from '../lib/api';

/** /invite/<code>: remember the code for this tab and continue to sign-in. */
export function InvitePage() {
  const { code } = useParams();
  const valid = Boolean(code && /^[A-Za-z0-9]{6,32}$/.test(code));
  useEffect(() => {
    if (valid && code) rememberInviteCode(code);
  }, [valid, code]);
  return <Navigate to="/signin" replace state={{ invite: valid }} />;
}
